import React from "react";
const Input = (props) => {
    return (
        <div className="ca-control">
            <label htmlFor={props.id}>{props.title}</label>
            <input
                name={props.name}
                id={props.id}
                className={`form-control ca-input ${props.isValid ? 'border-error' : ''}`}
                placeholder={props.placeholder}
                aria-label={props.name}
                readOnly={props.readOnly}
                value={props.value}
                onChange={props.onChange} />
        </div>
    )
}
export default Input;